<template>
  <div class="show-tax-selector">
    <button
      :class="['show-tax-selector__button', { 'show-tax-selector__button--selected': ! showTaxSelected }]"
      @click="toggleShowTax()"
    >
      Excl. VAT
    </button>
    <button
      :class="['show-tax-selector__button', { 'show-tax-selector__button--selected': showTaxSelected }]"
      @click="toggleShowTax()"
    >
      Incl. VAT
    </button>
  </div>
</template>

<script>
import { useUserStore } from "~/stores/user";

export default {
  props: {
    emitUpdates: Boolean,
  },
  setup() {
    return {
      userStore: useUserStore()
    }
  },
  data() {
    return {
      showTax: false,
    }
  },
  computed: {
    showTaxSelected() {
      return this.userStore.getShowProductTax
    }
  },
  methods: {
    toggleShowTax() {
      this.userStore.setShowProductTax(! this.showTaxSelected)
    }
  },
  watch: {
    showTaxSelected(newVal) {
      if (this.emitUpdates) {
        const taxOption = newVal ? 'Incl. VAT' : 'Excl. VAT'
        this.$emit('tax-selected', taxOption);
      }
    }
  }
}
</script>

<style lang="scss">
.show-tax-selector {
  display: flex;
  border: 1px solid;
  border-radius: 3px;
  &__button {
    border: 1px solid;
    padding: 0.5rem 2rem;
    flex-grow: 1;
    text-wrap-mode: nowrap;
    &--selected {
      background: #000;
      color: #fff;
    }
  }
}
</style>
